<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { HfarmCorporate } from "../../modules/hfarm_corporate_module.js";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default {
  mixins: [fandomBasicMixin],
  data: function () {
    return {
      popupOpen: false
    };
  },
  methods: {
    mayOpenPopup() {
      if (!this.link) {
        this.popupOpen = true;
        disableBodyScroll(this.$refs[`${this.popupId}-open-popup`])
      }
    },
    closePopup() {
      this.popupOpen = false;
      clearAllBodyScrollLocks();
    }
  },
  computed: {
    link() {
      return this.content.url ? this.content.url.url : null;
    },
    popupId() {
      const str = this.content.member_name || this.content.title;
      return str.replace(/ /g,'');
    }
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" v-if="isContentVisibleToUser()">
    <a :id="`${content.$id}-${popupId}-popup-link`" :href="link" @click="mayOpenPopup" :target="getTarget(content.url)">
      <slot></slot>
    </a>
    <transition enter-active-class="animated fadeIn fast" leave-active-class="animated fadeOut fast delay">
      <div class="position-fixed bg-white modal-background" v-if="popupOpen"></div>
    </transition>
    <transition enter-active-class="animated fadeInUp delay" leave-active-class="animated fadeOutDown">
      <div 
        v-if="popupOpen"
        :ref="`${popupId}-open-popup`"
        class="position-fixed w-100 h-100 bg-white" 
        people-popup-component
      >
        <div class="close cursor-pointer  position-absolute" @click="closePopup()">&times;</div>
        <div class="container d-flex flex-column justify-content-center align-items-begin">
          <div class="bg-cover-center rounded-circle photo mt-3" 
            v-if="content.member_photo && content.member_name" 
            :title="content.member_name"
            :style="{'background-image': `url(${content.member_photo.url})`}">
          </div>
          <h2 v-if="content.member_name" class="mb-0 mt-4">{{ content.member_name}}</h2>
          <h3 v-if="content.member_role" class="subtitle mb-0">{{ content.member_role }}</h3>
          <p v-if="content.member_bio" class="mt-3 pt-3" v-html="content.member_bio"></p>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss">

.modal-background,
[people-popup-component]  {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1090;
}

.delay {
  animation-delay: $animation-time-fast;
}

[people-popup-component] {

  padding: 10% 15%;
  font: MaisonNeue,Arial,sans-serif;
  overflow-y: auto !important;

  .close {
    right: 1.5rem;
    top: 1.5rem;
    font-size: 2rem;
    transition: .25s;

    &:hover {
      color: $gray-500;
    }
  }

  .photo {
    width: 4.75rem;
    height: 4.75rem;
  }

  .subtitle {
    font-size: 1.75rem;
    line-height: 2.375rem;
    font-weight: 100;
  }

}

</style>